import MortgageStepsItem from './MortgageStepsItem';

const MortgageSteps = ({ steps }) => {
  return (
    <section className="block fill">
      <div className="fixed" style={{ color: 'white' }}>
        <h3>Шаги к мечте</h3>
      </div>
      <div className="fixed columns">
        {steps.map((value, index) => (
          <MortgageStepsItem
            number={value.number}
            title={value.title}
            duration={value.duration}
            description={value.description}
            key={index}
          />
        ))}
      </div>
    </section>
  );
};

export default MortgageSteps;
